import {
    faqContactForm,
    setContactFAQPage,
    i18n,
} from "commonAssets/js/constants";
import { createElement } from "./createElement.js";
import { modal } from "./modal.js";
import { submitContactButton } from "./submitContactButton.js";
import { messageBox } from "./messageBox.js";
import { filterFaq } from "./filterFaq.js";

export function showContactFAQForm(userLanguage, page) {
    setContactFAQPage();
    const firstDropDown = faqContactForm.makeFirstContactDropDown();
    const faqContainer = createElement(
        "div",
        { id: "faq-category-select" },
        [],
        firstDropDown.outerHTML
    );
    const messageBoxHTML =
        faqContainer.outerHTML + messageBox(userLanguage).outerHTML;
    modal(i18n.getTranslation("contact_us"), messageBoxHTML, [
        submitContactButton(userLanguage),
    ]);
    const submitBtn = document.getElementById("submitContactFormBtn");
    if (submitBtn) {
        submitBtn.disabled = true;
    }

    setTimeout(() => {
        const element = document.getElementById("contactCategory");
        element.addEventListener("change", (e) => {
            filterFaq(e.target);
        });
    }, 250);
}
